export class NPCManager {

    npcs = {}

    reset() {
        this.npcs = {}
    }

    addNPC(e) {
        console.log("NPCManager::addNPC", e)
        this.npcs[e.getID()] = e
    }

    removeNPC(uid) {
        console.log("NPCManager::removeNPC", uid)
        delete this.npcs[uid]
    }

    /**
     * Update & override keys on the npc from data update
     * @param uid
     * @param data
     * @param animation
     */
    updateNPC(uid, data, animation = null) {
        const e = this.get(uid)
        if (e === null) {
            console.error("NPCManager::updateNPC", uid, "not found")
            return
        }
        // console.log("Updating npc", e, data)

        const dataKeys = Object.keys(data)
        for (let key in dataKeys) {
            // console.log("NPCManager::updateNPC", uid, key, dataKeys[key], data[dataKeys[key]])
            this.npcs[uid][dataKeys[key]] = data[dataKeys[key]]
        }

        if (animation !== null) {
            if (animation === "walk")
                return; //TODO stops the jump animation from fucking up

            this.npcs[uid].playAnimation(animation)
        }
    }

    frame = 0

    update(player) {
        if (!player && this.frame % 15) return

        for(let npc in this.npcs) {
            if (this.euclideanDistance(player, this.npcs[npc].obj) < 100) {
                this.npcs[npc].obj.visible = true
                continue
            }

            this.npcs[npc].obj.visible = false
        }
        this.frame++
    }

    inRange(player, npc) {
        return this.euclideanDistance(player, npc)
    }

	euclideanDistance(p1, p2) {
		const pos1 = p1.position
		const pos2 = p2.position

		return Math.sqrt((pos1.x - pos2.x) * (pos1.x - pos2.x) + (pos1.z - pos2.z) * (pos1.z - pos2.z))
	}

    all() {
        return this.npcs
    }

    get(uid) {
        return this.npcs[uid]
    }

    inArea(xmin, xmax, ymin, ymax) {
        return this.npcs.map(e => e.getPosition()).filter(p => p.x >= xmin && p.x <= xmax && p.y >= ymin && p.y <= ymax)
    }

    getNPCSOfType(typ) {
        var ents = {}
        for (let e in this.npcs) {
            if (e.getType() === typ) {
                ents[e.uid] = e
            }
        }
        return ents;
    }

    /**
     * Main animation loop
     * @param delta
     */
    animate(delta) {
        for (let e in this.npcs) {
            this.npcs[e].animate(delta)
        }
    }
}
